// extracted by mini-css-extract-plugin
export default {"marginButton":"DrawerDocs_marginButton__wemJo","green":"DrawerDocs_green__-+hzW"};